import { motion } from "framer-motion";

/**
 * Reveal — simple in-view reveal (opacity + subtle y).
 */
export default function Reveal({
  children,
  delay = 0,
  y = 24,
  duration = 0.8,
  className = "",
  once = true,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{
        duration,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
